import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Cargar las variables configurables.
 * 
 * @param {*} commit
 * @param Integer companyId (empresa)
 * @param Integer page (Pagina actual)
 * @return {Promise<void>}
 * @author Fernando CLaros Garcia
 */
export async function loadConfigurableVariables({ commit }, { companyId, page, pagination = 1, status }) {
  
  // Limpiar el listado actual. 
  commit('setConfigurableVariables', [])

  // Cargando
  commit('dashboard/load', true, { root: true });
  
  await $http.get(`companies-country/get-all/by-company/${companyId}/${status}/pagination/${pagination}?page=${page}`)
    .then(({ data: response }) => commit('setConfigurableVariables', response.payload))
    .catch(() => {
      callbackGenerateAlert(
        'error',
        'Error al tratar de cargar las variables configurables.'
      );
    })
    .finally(() => commit('dashboard/load', false, { root: true }));

}

/**
 * Crear variables configurables.
 *
 * @param commit
 * @param dispatch
 * @param object payload: datos para la varaible configurable.
 * @return {Promise<void>}
 * @author Fernando CLaros Garcia
 */
export async function storeConfigurableVariable({ commit, dispatch }, payload) {
  commit('dashboard/load', true, { root: true });

  await $http.post('companies-country', payload)
    .then(({ data: response }) => {

      callbackUpdateOrCreateConfigureVariable(
        response.message,
        payload.slq_company_id,
        commit,
        dispatch,
        payload.page,
        payload.status
      );

    })
    .catch(() => {
      callbackGenerateAlert(
        'info',
        'Error al tratar de realizar la acción con la Varaible configurable.'
      );
    })
    .finally(() => commit('dashboard/load', false, { root: true }));

}

/**
 * Actualizar variables configurables.
 *
 * @param commit
 * @param dispatch
 * @param object payload: datos para la varaible configurable.
 * @return {Promise<void>}
 * @author Fernando CLaros Garcia
 */
export async function updateConfigurableVariable({ commit, dispatch }, payload) {
  commit('dashboard/load', true, { root: true });

  await $http.put(`companies-country/${payload.id}`, payload)
    .then(({ data: response }) => {

      callbackUpdateOrCreateConfigureVariable(
        response.message,
        payload.slq_company_id,
        commit,
        dispatch,
        payload.page,
        payload.status
      );
      
    })
    .catch(() => {
      callbackGenerateAlert(
        'error',
        'Error al tratar de realizar la acción con la Varaible configurable.'
      );
    })
    .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Proceso a realizar despues de crear/editar variables configurables.
 * 
 * @param {*} text 
 * @param {*} companyId 
 * @author Fernando CLaros Garcia
 */
function callbackUpdateOrCreateConfigureVariable(text, companyId, commit, dispatch, page, status = 'ALL') {
  // Generar alerta de proceso exitoso
  callbackGenerateAlert('success', text, true);

  // Procesar la información
  commit('setDefaultConfigurableVariable');
  commit('setModalForm', {
    isOpen: false,
    action: 'CREATE'
  });

  dispatch('loadConfigurableVariables', { companyId, page, status });
}


/**
 * Generar alarta para notificar variables configurables.
 * 
 * @param {*} icon: (info, success, error) 
 * @param {*} text 
 * @author Fernando CLaros Garcia
 */
function callbackGenerateAlert(icon = 'info', text = '', showConfirmButton = false) {
  Swal.fire({
    position: 'center',
    icon,
    title: 'Variables configurables',
    text,
    showConfirmButton
  })
}